export default __webpack_public_path__ + "static/media/loading.d6fa3d56.gif";